import { t } from "@/i18n-js/instance";
import { Loader } from "@circle-react-uikit/Loader";
import { Typography } from "@circle-react-uikit/Typography";

export const ImageLoader = () => (
  <div className="bg-secondary border-primary flex aspect-video w-full flex-col items-center justify-center gap-2 rounded-lg border border-dashed">
    <Loader className="!p-0" />
    <Typography.LabelXs>{t("uploading")}...</Typography.LabelXs>
  </div>
);
